import { memo } from 'react'
import { COLUMN_OFFSET, ROW_OFFSET } from '$features/calendar/constants'
import { Appointment } from '$api-client/types.gen'
import { AppointmentCard } from './appointment'

type AppointmentPosition = {
  data: Appointment
  position: { column: number; slotStart: number; slotEnd: number }
  offset: { top: number; left: number }
  height: number
  width: number
}

type AppointmentsProps = {
  appointmentPositions: Array<Array<AppointmentPosition>>
}

export const Appointments = memo(function Appointments({
  appointmentPositions,
}: AppointmentsProps) {
  return (
    <>
      {appointmentPositions.map((group) =>
        group.map((appointment, key) => (
          <div
            key={key}
            style={{
              gridColumnStart: appointment.position.column + COLUMN_OFFSET,
              gridColumnEnd: appointment.position.column + COLUMN_OFFSET,
              gridRowStart: appointment.position.slotStart + ROW_OFFSET,
              gridRowEnd: appointment.position.slotEnd + ROW_OFFSET,

              top: (appointment.offset.top + 1) + 'px',
              left: (appointment.offset.left + 1) + 'px',

              maxHeight: (appointment.height + 1) + 'px',
              height: (appointment.height - 1) + 'px',
              width: (appointment.width - 1) + 'px',
            }}
            className="absolute"
          >
            <AppointmentCard data={appointment.data} />
          </div>
        )),
      )}
    </>
  )
})
